import {gql} from '@apollo/client';

const CREATE_COUNTRY = gql`
  mutation createCountry(
    $name: String!
    $businessRegion: String!
    $currency: Currency!
    $repairCostDimension: ValueDimension!
    $maintenanceCostDimension: ValueDimension!
    $countryCodes: [String!]!
  ) {
    createCountry(
      input: {
        name: $name
        businessRegion: $businessRegion
        currency: $currency
        repairCostDimension: $repairCostDimension
        maintenanceCostDimension: $maintenanceCostDimension
        countryCodes: $countryCodes
      }
    ) {
      id
      name
      businessRegion
      currency
      repairCostDimension
      maintenanceCostDimension
      countryCodes
    }
  }
`;

export default CREATE_COUNTRY;
